import { isBeta, isDev, isProd } from 'shared/utils/env'

// Cloudflare Image Transformations are only proxying deployed environments
// (proxied/orange-cloud DNS). Locally there is no Cloudflare in front of the
// dev server, so /cdn-cgi/image would 404 — fall back to the raw src there.
const isCloudflareProxied = isProd || isBeta || isDev

// Cloudflare expects the source path without a leading slash when it follows
// the transformation options, e.g. /cdn-cgi/image/width=800/images/foo.jpg
const normalizeSrc = (src: string) => (src.startsWith('/') ? src.slice(1) : src)

type CloudflareLoaderParams = {
  src: string
  width: number
  quality?: number
}

export default function cloudflareImageLoader({
  src,
  width,
  quality
}: CloudflareLoaderParams): string {
  if (!isCloudflareProxied) {
    return src
  }

  const params = [
    `width=${width}`,
    `quality=${quality ?? 75}`,
    'format=auto',
    'fit=scale-down'
  ].join(',')

  return `/cdn-cgi/image/${params}/${normalizeSrc(src)}`
}
